
  import { setup } from 'storybook/internal/preview/runtime';

  setup();

  import { createBrowserChannel } from 'storybook/internal/channels';
  import { addons } from 'storybook/internal/preview-api';

  const channel = createBrowserChannel({ page: 'preview' });
  addons.setChannel(channel);
  window.__STORYBOOK_ADDONS_CHANNEL__ = channel;

  if (window.CONFIG_TYPE === 'DEVELOPMENT'){
    window.__STORYBOOK_SERVER_CHANNEL__ = channel;
  }

  import { composeConfigs, PreviewWeb } from 'storybook/internal/preview-api';
  import { isPreview } from 'storybook/internal/csf';

  const importers = {
      ...import("story:Li4vLi4vLi4vLi4vLnN0b3J5Ym9vay1zMi9kb2NzLyoubWR4"),
...import("story:Li4vLi4vLi4vQHJlYWN0LXNwZWN0cnVtL3MyL3N0b3JpZXMvKi5zdG9yaWVzLkAoanN8anN4fG1qc3x0c3x0c3gp")
    };

    async function importFn(path) {
      return importers[path]();
    }

  const getProjectAnnotations = async () => {
    const configs = await Promise.all([import('@storybook/react/dist/entry-preview.mjs'),
import('@storybook/react/dist/entry-preview-docs.mjs'),
import('@storybook/react/preview'),
import('@storybook/addon-links/preview'),
import('@storybook/addon-essentials/actions/preview'),
import('@storybook/addon-essentials/docs/preview'),
import('@storybook/addon-essentials/backgrounds/preview'),
import('@storybook/addon-essentials/viewport/preview'),
import('@storybook/addon-essentials/measure/preview'),
import('@storybook/addon-essentials/outline/preview'),
import('@storybook/addon-essentials/highlight/preview'),
import('@storybook/addon-interactions/preview'),
import('@storybook/addon-a11y/preview'),
import('../../../../.storybook-s2/preview.tsx')])
    return composeConfigs(configs);
  }


  window.__STORYBOOK_PREVIEW__ = window.__STORYBOOK_PREVIEW__ || new PreviewWeb(importFn, getProjectAnnotations);

  window.__STORYBOOK_STORY_STORE__ = window.__STORYBOOK_STORY_STORE__ || window.__STORYBOOK_PREVIEW__.storyStore;


  module.hot.accept(() => {
    // importFn has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onStoriesChanged({ importFn });

    // getProjectAnnotations has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onGetProjectAnnotationsChanged({ getProjectAnnotations });
  });
 